import React from "react";
import { DescriptionLoader, DeveloperLoader, ImageLoader, PriceLoader, TitleLoader } from "./LoaderCommon";
import style from '../../style/news.module.css';

export default function NewsLoader() {
    return (
        <div className="our-project-card">
            <div className="blog-card-img h-auto">
                <ImageLoader />
            </div>
            <div className="blog-info-data">
                <h2>
                    <TitleLoader />
                </h2>
                <div className={style.news_description}>
                    <DescriptionLoader />
                </div>
                <div>
                    <PriceLoader />
                </div>
            </div>
            <div className="news-date-time" style={{borderTop:"1px solid #f5f6f7"}}>
                <p>
                    <DeveloperLoader />
                </p>
                <p>
                    <DeveloperLoader />
                </p>
            </div>
        </div>
    );
}
